import { CloseOutlined } from "@ant-design/icons";

import { Button, Input, Modal } from "antd";
import React, { FC, useState } from "react";

import styles from "@/components/Pledge/DownloanModal/DownloanModal.module.css";

interface DownloanModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: string) => void;
  initialDownloanAmount: number;
}

const DownloanModal: FC<DownloanModalProps> = ({
  open,
  onClose,
  onSubmit,
  initialDownloanAmount,
}) => {
  const [inputData, setInputData] = useState(
    initialDownloanAmount !== undefined && initialDownloanAmount !== null
      ? Number(initialDownloanAmount).toFixed(2)
      : "",
  );

  const submitHandler = () => {
    onSubmit(inputData ? Number(inputData).toFixed(2) : "");
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      className={styles.otpModal}
      width={600}
    >
      <button className={styles.closeBtn} onClick={onClose}>
        <CloseOutlined />
      </button>
      <div className={styles.modalContainer}>
        <span className={styles.header}>Enter Downloan Amount</span>
        <div className={styles.infoContainer}>
          <span>Enter the amount you wish to pay to reduce your loan balance.</span>
        </div>
        <Input
          value={inputData}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9.]/g, "");
            setInputData(value);
          }}
          onBlur={() => {
            if (inputData) {
              setInputData(Number(inputData).toFixed(2));
            }
          }}
          className={styles.customInput}
        />
      </div>

      <Button className={styles.applyButton} onClick={submitHandler} block>
        Proceed
      </Button>
    </Modal>
  );
};

export default DownloanModal;
